<template>
  <div style="text-align: justify">
    <h2 class="mb-4">Standardization of NaOH</h2>

    <p class="mb-6">
      The following data were collected during the titration of a solid sample of potassium acid
      phthalate ("KHP") with a solution of sodium hydroxide. The NaOH solution was added to the KHP
      from a buret.
    </p>

    <p class="mb-6">
      From the experimental data given below, calculate the <b>molarity</b> of the NaOH solution. Be
      sure to enter your units in the second input field.
    </p>

    <p class="mb-5">
      <u>Data:</u>
    </p>

    <v-simple-table style="margin-left: 5px; margin-bottom: 20px; max-width: 513px">
      <thead>
        <tr>
          <td>Molar mass of potassium acid phthalate</td>
          <td>
            <stemble-latex content="$204.223~\text{g/mol}$" />
          </td>
        </tr>
        <tr>
          <td>Mass of KHP bottle BEFORE removing sample</td>
          <td>
            <latex-number :number="bottleAndKHP" unit="\text{g}" />
          </td>
        </tr>
        <tr>
          <td>Mass of KHP bottle AFTER removing sample</td>
          <td>
            <number-value :value="bottle" unit="\text{g}" />
          </td>
        </tr>
        <tr>
          <td>Initial Buret Reading</td>
          <td>
            <number-value :value="Vi" unit="\text{mL}" />
          </td>
        </tr>
        <tr>
          <td>Final Buret Reading</td>
          <td>
            <number-value :value="Vf" unit="\text{mL}" />
          </td>
        </tr>
      </thead>
    </v-simple-table>

    <v-row>
      <v-col cols="5">
        <calculation-input
          v-model="inputs.concNaOH"
          prepend-text="$\ce{[NaOH]:}$"
          :disabled="!allowEditing"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="inputs.units" prefix="Units:" outlined :disabled="!allowEditing" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import LatexNumber from '../displayers/LatexNumber';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default {
  name: 'NaOHStandardizationQuestion',
  components: {
    CalculationInput,
    StembleLatex,
    NumberValue,
    LatexNumber,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        concNaOH: null,
        units: null,
      },
    };
  },
  computed: {
    KHP() {
      return this.taskState.getValueBySymbol('KHP').content;
    },
    bottle() {
      return this.taskState.getValueBySymbol('bottle').content;
    },
    Vi() {
      return this.taskState.getValueBySymbol('Vi').content;
    },
    Vf() {
      return this.taskState.getValueBySymbol('Vf').content;
    },
    bottleAndKHP() {
      return (this.KHP.toFloat() + this.bottle.toFloat()).toFixed(4);
    },
  },
};
</script>
